module.exports = __webpack_public_path__ + "static/media/high-fi-2.78bbdf37.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/high-fi-2.png
// module id = 202
// module chunks = 0